import { LinearTransition } from 'react-native-reanimated';

// TODO: export these from SK-UI so the app does not keep its own copy.
const QUICKEST_DAMPING = 14;
const QUICKEST_MASS = 0.1;
const QUICKEST_STIFFNESS = 380;

export const INSIGHTS_MOBILE_LAYOUT_TRANSITION = LinearTransition.springify()
  .damping(QUICKEST_DAMPING)
  .mass(QUICKEST_MASS)
  .stiffness(QUICKEST_STIFFNESS);
